export default __webpack_public_path__ + "static/cleaning-96d22533dc10c6028113f6c1e1948b27.svg";